import { useStorage } from '@front-app/hooks/useLocalStorage';

export const inviteCampaignEmailStorage = useStorage('invite_campaign_emails');
